'use client';

import { ReactNode } from 'react';
import { SessionProvider } from 'next-auth/react';

export default function NextAuthSessionProvider({ children }: { children: ReactNode }) {
  return (
    <SessionProvider
      refetchInterval={0} // 주기적 갱신 비활성화 (필요시에만 수동 갱신)
      refetchOnWindowFocus={false} // 윈도우 포커스 시 자동 갱신 비활성화
    >
      {children}
    </SessionProvider>
  );
}
